import { render, staticRenderFns } from "./currentAgreement.vue?vue&type=template&id=22242dd0&scoped=true&"
import script from "./currentAgreement.vue?vue&type=script&lang=js&"
export * from "./currentAgreement.vue?vue&type=script&lang=js&"
import style0 from "./currentAgreement.vue?vue&type=style&index=0&id=22242dd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22242dd0",
  null
  
)

export default component.exports